<script lang="ts" setup>
import { Dialog, DialogContent, DialogClose, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '~/components/ui/dialog'
import { Button } from '~/components/ui/button'

const isOpen = ref(false)
const eventBus = useEventBus()
const userStore = useUserStore()
const hasWalletsForBonus = computed(() => {
	return !!userStore.wallets.count && userStore.wallets.count < userStore.wallets.limit
})

watchEffect(() => {
	if (process.client) {
		eventBus.on('maybeOpenJobtokenSuccess', async() => {
      if(userStore.wallets.count === null) {
        await userStore.getWalletsCount()
      }
      if(!hasWalletsForBonus.value) return
			isOpen.value = true
		})
	}
})
</script>

<template>
  <Dialog v-model:open="isOpen">
		<DialogContent class="ys-modal-dialog w-full overflow-hidden border-none">
			<DialogClose class="absolute top-4 ltr:right-4 rtl:left-4">
				<Icon name="ri:close-line" size="20px" class="text-gray-500 translate-all hover:text-gray-700" />
			</DialogClose>
			
			<div class="p-4">
		<div class="text-center">
			<video 
				src="/img/jobtoken/logo-present.webm" 
				class="mx-auto mb-6 aspect-video object-cover" 
				autoplay 
				muted 
				playsinline
			></video>

			<DialogHeader>
				<DialogTitle class="text-lg font-bold">
					{{ $t('Congratulations!') }}
				</DialogTitle>
				<DialogDescription class="text-sub mb-6">
					{{ $t('Your jobtoken has been sent to your TON wallet address!') }}
				</DialogDescription>
			</DialogHeader>

			<DialogFooter class="flex flex-col gap-4">
				<DialogClose class="w-full" as-child>
					<Button variant="primary" class="w-full">
						{{ $t('Hooray!') }}
					</Button>
				</DialogClose>
			</DialogFooter>
		</div>
	</div>
		</DialogContent>
	</Dialog>
</template>